<template>
  <section class="grid-flex column">
    <div class="flex w100">
      <div class="box">
        <div class="box-title flex middle">
          <div class="flex column">
            <h3>Domínios</h3>
            <p class="margin-top-s">Personalize seus Links Rastreaveis com seu próprio dominio.</p>
          </div>
          <div class="flex-1 flex end">
            <div class="no-mobile flex column" style="margin-right: 16px">
              Quantidade de Dominios: {{ account.used_limits.limit_domain | number }} / {{ account.plan_limits.limit_domain | number }}
              <div class="margin-top-s">Precisa de mais dominios? <router-link :to="{ name: 'SubscriptionRedirect' }">Faça Upgrade</router-link></div>
            </div>
            <div class="button primary" @click="openModalCreate()">
              Adicionar Novo Domínio
            </div>
          </div>
        </div>
        <div class="box-content">
          <ul>
            <li v-for="(w, index) in domains" :key="index">
              <div class="flex">
                <div class="flex-2">
                  <div><b>{{ w.domain }}</b></div>
                  <div class="margin-top-s">Status: {{ _decode_status(w.status) }}</div>
                </div>
                <div class="flex-1 flex end">
                  <div class="button primary" v-if="w.status === 'AWAITING'" @click="checkDomainDns(w.id)">Validar</div>
                  <div class="button secondary" @click="newDomain=w; showModalCreate = true">Editar</div>
                  <div class="button secondary" @click="selectedDomain=w; showModalDelete = true">Deletar</div>
                </div>
              </div>
            </li>
          </ul>
          <div v-if="loading">
            <content-loading>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
              <fake-line height="30"></fake-line>
            </content-loading>
          </div>
          <div v-if="isEmpty">
            Você não tem dominios. Adicione o seu primeiro dominio e melhore seu trackeamento.
          </div>
        </div>
      </div>
    </div>

    <!-- modal confirm delete -->
    <modal-confirm
        :show="showModalDelete"
        description="Você tem certeza que deseja deletar este dominio?"
        @cancel="
          showModalDelete = false;
          selectedDomain = null;
        "
        @accept="deleteDomain(selectedDomain)"
      ></modal-confirm>

      <modal
        :title="titleModal"
        :show="showModalCreate"
        @close="cleanModal()"
      >
        <div class="content flex column " slot="content">
          <form autocomplete="off" class="w100">
              <div class="flex-1 w100">
                <label>Sub Domínio</label>
                <input
                  class="input"
                  id="name"
                  type="text"
                  v-model="newDomain.domain"
                  autocomplete="off"
                />
              </div>
              <div class="flex-1 w100">
                <p>Para ativar seu sub dominio. Crie os 2 registros abaixo:</p>
                <p>1) CNAME do Sub Dominio com valor: r.lh4.me</p>
                <p>2) TXT na Raiz "@" com o valor: UNICOTRACKER#{{ account.id }}#</p>
              </div>
            </form>
          <div class="flex column w100">
            <div class="flex w100 center margin-top-l">
              <div class="button primary" @click="createOrUpdateDomain()">SALVAR</div>
            </div>
          </div>
        </div>
      </modal>
  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  createDomain,
  getDomains,
  deleteDomain,
  updateDomain,
  checkDomainDns,
} from "@/services/domain";

import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";


export default {
  name: "domain",
  components: {
    Modal,
    ModalConfirm,
  },
  data() {
    return {
      showModalDelete: false,
      selectedDomain: null,
      showModalQR: false,
      showModalCreate: false,
      loading: false,
      newDomain: {
        name: '',
        rule_name: '',
        event_name: '',
        event_value: '',
        platform: '',
      },
      domains: [],
    };
  },
  watch: {
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    titleModal() {
      if (this.newDomain.id) {
        return 'Editar Domínio'
      }

      return 'Criar nova Domínio'
    },
    isEmpty() {
      return !this.loading && this.domains && this.domains.length === 0
    },
    alertLimit() {
      if (this.account && this.account.plan_limits.limit_domain <= this.account.used_limits.limit_domain) {
        return true
      }

      return false
    },
  },
  mounted() {
    this.getDomains();
  },
  methods: {
    openModalCreate() {
      if(this.alertLimit) {
        this.$toast.error({
          title:'Erro',
          message:'Você já está usando o limite de dominios do seu plano! Faça upgrade para criar mais!'
        })

        return

      }
      
      this.showModalCreate = true
    },
    _decode_status(status) {
      let _map = {
        'ACTIVE': 'ATIVO',
        'AWAITING': 'AGUARDANDO VALIDAÇÃO',
        'DISABLED': 'DESATIVADO'
      }

      return  _map[status] || status
    },
    cleanModal() {
      this.newDomain = {
        url: '',
      }
      this.showModalCreate = false
    },
    createOrUpdateDomain() {
      if (this.newDomain.id) {
        this.updateDomain()
      } else {
        this.createDomain()
      }
    },
    checkDomainDns(domainId) {
      checkDomainDns(domainId)
        .then((result) => {
          this.$toast.success({
            title:'Sucesso',
            message:'Dominio validado com sucesso. Pronto para uso!'
          })
          // update status domain
          this.domains.forEach(e => {
            if (e.id === domainId) {
              e.status = result.status
            }
          });
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema na validação do dominio. Verifique a configuração!'
          })
        })
    },
    createDomain() {
      let data = {
        domain: this.newDomain.domain,
      };

      if (!data.domain) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar o Dominio",
        });
      }
      createDomain(data)
        .then((result) => {
          this.$toast.success({
            title: "Sucesso",
            message: "Página salva com sucesso",
          });

          this.domains.push(result)
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar Dominio",
          });
        })
        .finally(() => {
          this.showModalCreate = false
        })
    },
    getDomains() {
      this.loading = true
      getDomains()
        .then((result) => {
          this.domains = result.domains
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar páginas",
          });
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateDomain() {
      let params = {
        domain: this.newDomain.domain,
      }
      updateDomain(this.newDomain.id, params)
        .then((result) => {
          this.$toast.success({
            title:'Sucesso',
            message:'Editado com sucesso'
          })

          // update status domain
          this.domains.forEach(e => {
            if (e.id === this.newDomain.id) {
              e.status = result.status
            }
          });
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.showModalCreate = false
          this.selectedDomain = null
        })
    },
    deleteDomain(page) {
      deleteDomain(page.id)
        .then(() => {
          this.$toast.success({
            title:'Sucesso',
            message:'Removido com sucesso'
          })
          this.domains = this.domains.filter(e => e.id != page.id)
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.showModalDelete = false
          this.selectedDomain = null
        })
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
  border-bottom: 1px solid #dfdfdf;
  margin-bottom: 16px;
  padding: 16px 4px;
  .button {
    margin-right: 8px;
  }
}

</style>
